<template>
  <div class="pay-here-content">
    <h2>Check-in</h2>
    <div class="steps-module-content">
      <StepsBar :steps="steps" />
    </div>
    <div class="step-view">
      <router-view
        @enableNextButton="enableNextButton=$event"
        @enableBackButton="enableBackButton=$event"
        @sendNameNextStep="setNextStepName"
        @sendNameBackStep="setBackStepName"
        @set-event-next="setEventNext"
        @showModal="isModalActive=true"
        @hideModal="isModalActive=false" />
    </div>
  </div>
</template>

<script>
import StepsBar from '@/ui/components/steps/StepsBar.vue';

export default {
  name: 'CheckIn',
  components: { StepsBar },
  data() {
    return {
      nextStepName: '',
      backStepName: '',
      eventNext: () => {},
      enableNextButton: false,
      enableBackButton: true,
      steps: [
        {
          text: '1. Bienvenida',
          paths: [
            {
              path: 'bienvenida',
              showFooter: true,
              showNextButton: true
            }
          ]
        },
        {
          text: '2. Check-in',
          paths: [
            {
              path: 'terminos',
              showFooter: true,
              showNextButton: true
            }
          ]
        },
        {
          text: '3. Confirma',
          paths: [
            {
              path: 'confirma',
              showFooter: true,
              showNextButton: true
            }
          ]
        }
      ],
      isModalActive: false,
      modalProps: {
        title: '',
        content: '',
        html: '',
        footer: '',
        buttonAction: '',
        buttonText: ''
      }
    };
  },
  computed: {
    currentPath() {
      const pathSplit = this.$route.path.split('/');
      return pathSplit[pathSplit.length - 1];
    },
    currentStep() {
      const { currentPath } = this;
      return this.steps.find(step => {
        return step.paths.find(({ path }) => {
          return path === currentPath;
        });
      });
    },
    showFooter() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.showFooter;
    },
    showNextButton() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.showNextButton;
    }
  },
  mounted() {},
  methods: {
    async continueNext() {
      if (this.eventNext) await this.eventNext();
      if (this.nextStepName !== '') { this.$router.push({ name: this.nextStepName }); }
    },
    returnBack() {
      if (this.backStepName !== '') this.$router.push({ name: this.backStepName });
    },
    setNextStepName(value) {
      this.nextStepName = value;
    },
    setBackStepName(value) {
      this.backStepName = value;
    },
    setEnableButton(value) {
      this.enableButton = value;
    },
    setEventNext(event) {
      this.eventNext = event || undefined;
    },
    checkClientBelongsToArmas() {
      return true;
    }
  }
};
</script>
<style scoped>
  .pay-here-content{
    padding-bottom: 70px;
  }
  .steps-module-content{
    margin: auto;
  }

  .footer-resume {
    position: fixed;
    background-color: var(--color-snow);
    padding: 20px 60px;
    border-top-left-radius: 35px;
    border-top-right-radius: 35px;
    box-shadow: 0px -4px 8px #00000014;
    left: calc(4% + 230px);
    right: 4%;
    bottom: 0;
    -webkit-transform: translateY(calc(100% + 4px));
    transform: translateY(calc(100% + 4px));
  }
  .footer-resume.active {
    -webkit-transform: translateY(0%);
    transform: translateY(0%);
  }
  .footer-resume .total-content{
    width: 50%;
    float: left;
    font-size: 18px;
    padding: 6px 0px;
    text-align: center;
  }
  .footer-resume .total-content span{
    color: var(--primary);
  }
  .footer-resume .button-content{
    float: left;
    width: 25%;
    min-height: 1px;
  }
  .footer-resume .button-content .button{
    display: block;
    margin: auto;
  }
  .modal-card-body {
    position: relative;
    padding-bottom: 40px;
  }
  .modal-card-body .close-modal {
    position: absolute;
    right: 20px;
    top:20px;
    width: 40px;
  }
  .modal-title{
    font-size: 18px;
    margin-bottom: 20px;
    padding-top: 40px;
  }
  .modal-content{
    margin-bottom: 30px;
    font-size: 14px;
    width: 100%;
    max-width: 400px;
  }
  .modal-footer{
    margin-bottom: 30px;
    font-size: 12px;
  }
  .close-modal {
    position: absolute;
    right: 20px;
    top:20px;
    width: 40px;
  }

  @media (max-width: 1100px) {
    .footer-resume .total-content{
    font-size: 14px;
    }
  }
  @media (max-width: 1024px) {
    .footer-resume {
      left: calc(4% + 190px);
    }
  }

  @media (max-width: 768px) {
    .image-check-in {
      margin: 0px auto;
    }
    .footer-resume {
      left: 4%;
      padding-top: 60px;
    }
    .footer-resume .total-content{
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 15px;
    }
    .footer-resume .button-content {
      width: 50%;
    }
    .footer-resume .button-content.complete {
      width: 100%;
    }
    .footer-resume .button-content.hidden {
      width: 0%;
    }
     .footer-resume .button-content .button{
      width: auto;
    }
  }
  @media (max-width: 400px) {
    .footer-resume .button-content .button{
      padding: 10px 20px;
      font-size: 10px;
    }
  }
</style>
